import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  // Helmet meta info (strings only)
  pageTitleString: 'KitStart',
  pageDescriptionString: 'KitStart page',

  // JSX components for display
  pageTitle: <PortalMessage id='t.app.kitstart.main.pageTitle' defaultMessage='KitStart' />,
  pageDescription: <PortalMessage id='t.app.kitstart.main.pageDescription' defaultMessage='KitStart page' />,

  // Toast and validation messages
  validationErrorString: <PortalMessage id='t.app.kitstart.main.validationErrorString' defaultMessage='Devi selezionare almeno un servizio aggiuntivo per proseguire.' />,
  toastErrorString: <PortalMessage id='t.app.kitstart.main.toastErrorString' defaultMessage='Devi selezionare almeno un servizio aggiuntivo per proseguire.' />,

  // Progress bar
  stepLabel: <PortalMessage id='t.app.kitstart.main.stepLabel' defaultMessage='Attivazione servizi' />,

  // Main content
  titlePage: <PortalMessage id='t.app.kitstart.main.titlePage' defaultMessage='Prodotti e servizi' />,

  // Casistica T0 - tutti servizi disponibili per attivazione
  titleCardT0: <PortalMessage id='t.app.kitstart.main.titleCardT0' defaultMessage='Richiedi i tuoi servizi aggiuntivi' />,
  subtitleCardT0: <PortalMessage id='t.app.kitstart.main.subtitleCardT0' defaultMessage='Personalizza la tua esperienza su Nexi Business scegliendo tra i servizi pensati per gestire al meglio la tua attività.' />,

  // Casistica T1 - almeno un servizio in attivazione
  titleCardT1: <PortalMessage id='t.app.kitstart.main.titleCardT1' defaultMessage='Personalizza la tua esperienza su Nexi Business scegliendo tra i servizi pensati per gestire al meglio la tua attività.' />,
  // Per T1 non c'è sottotitolo

  // Casistica T2 - servizi già attivati + altri disponibili
  subtitleCardT2: <PortalMessage id='t.app.kitstart.main.subtitleCardT2' defaultMessage='Personalizza la tua esperienza su Nexi Business scegliendo tra i servizi pensati per gestire al meglio la tua attività.' />,

  // Backwards compatibility - da rimuovere eventualmente
  titleCard: <PortalMessage id='t.app.kitstart.main.titleCard' defaultMessage='Richiedi i tuoi servizi aggiuntivi' />,
  titleCardWithT1Services: <PortalMessage id='t.app.kitstart.main.titleCardWithT1Services' defaultMessage='Personalizza la tua esperienza su Nexi Business scegliendo tra i servizi pensati per gestire al meglio la tua attività.' />,
  subtitleCard: <PortalMessage id='t.app.kitstart.main.subtitleCard' defaultMessage='Personalizza la tua esperienza su Nexi Business scegliendo tra i servizi pensati per gestire al meglio la tua attività.' />,
  titleCardWithActivated: (count) => <PortalMessage id='t.app.kitstart.main.titleCardWithActivated' defaultMessage='Ti mancano {count} servizi aggiuntivi da richiedere!' values={{ count }} />,
  titleCardWithActivatedSingle: <PortalMessage id='t.app.kitstart.main.titleCardWithActivatedSingle' defaultMessage='Ti manca 1 servizio aggiuntivo da richiedere!' />,

  // Buttons
  continueLabel: <PortalMessage id='t.app.kitstart.main.continue' defaultMessage='continua' />,
  closeLabel: <PortalMessage id='t.app.kitstart.main.close' defaultMessage='Chiudi' />,
  showLabel: <PortalMessage id='t.app.kitstart.main.show' defaultMessage='MOSTRA' />,
  hideLabel: <PortalMessage id='t.app.kitstart.main.hide' defaultMessage='NASCONDI' />,
  selectAllLabel: <PortalMessage id='t.app.kitstart.main.selectAll' defaultMessage='Seleziona tutti' />,

  // Validation messages
  validationError: <PortalMessage id='t.app.kitstart.main.validationError' defaultMessage='Seleziona almeno un servizio per continuare' />,
  toastError: <PortalMessage id='t.app.kitstart.main.toastError' defaultMessage='Seleziona almeno un servizio per continuare' />,

  // Sections
  activatedServicesTitle: <PortalMessage id='t.app.kitstart.main.activatedServicesTitle' defaultMessage='Servizi già attivati' />,
  serviceAlreadyActiveLabel: <PortalMessage id='t.app.kitstart.main.serviceAlreadyActive' defaultMessage='Servizio già attivo' />,
  noServicesMessage: <PortalMessage id='t.app.kitstart.main.noServicesMessage' defaultMessage='Nessun servizio disponibile al momento.' />,
  additionalInfoLabel: <PortalMessage id='t.app.kitstart.main.additionalInfo' defaultMessage='Informazioni aggiuntive' />,

  // Micropayments service
  micropaymentsTitle: <PortalMessage id='t.app.kitstart.main.micropayments.title' defaultMessage='Micropagamenti' />,
  micropaymentsSubtitle: <PortalMessage id='t.app.kitstart.main.micropayments.subtitle' defaultMessage='Zero commissioni sugli importi fino a 10€.' />,
  micropaymentsAmount: <PortalMessage id='t.app.kitstart.main.micropayments.amount' defaultMessage='0%' />,
  micropaymentsCommissionText: <PortalMessage id='t.app.kitstart.main.micropayments.commissionText' defaultMessage='di commissioni' />,
  micropaymentsCommissionDesc: <PortalMessage id='t.app.kitstart.main.micropayments.commissionDesc' defaultMessage='per tutte le transazioni sotto 10€' />,
  micropaymentsText1: (expirationDate) => (
    <PortalMessage
      id='t.app.kitstart.main.micropayments.text1'
      defaultMessage="Aderisci gratuitamente all'iniziativa entro il {expirationDate} e ottieni il <b>rimborso delle commissioni per 12 mesi dal momento dell'adesione per le transazioni di importo fino a 10€</b> con i circuiti Visa, Mastercard, Bancomat."
      values={{ expirationDate }}
    />
  ),
  micropaymentsText2: <PortalMessage id='t.app.kitstart.main.micropayments.text2' defaultMessage='Il rimborso avverrà mensilmente <b>fino a un massimo di 50€ mensili per punto vendita</b> e lo troverai direttamente nel tuo estratto conto sotto la voce «Rimborso Micropagamenti».' />,
  micropaymentsText3: <PortalMessage id='t.app.kitstart.main.micropayments.text3' defaultMessage={'Rientrano nell\'iniziativa <b>solo le transazioni effettuate tramite POS fisici, SoftPOS e Pay-by-Link</b>. Il rimborso delle commissioni Micropagamenti si applica alle sole commissioni "bancarie" indicate sull\'estratto conto commissionale del servizio di acquiring dell\'esercente e non ad eventuali commissioni tecniche regolate tramite fattura.'} />,
  micropaymentsText4: <PortalMessage id='t.app.kitstart.main.micropayments.text4' defaultMessage='Messaggio pubblicitario con finalità promozionale. Per maggiori informazioni vai al' />,
  micropaymentsRegulationNexi: <PortalMessage id='t.app.kitstart.main.micropayments.regulationNexi' defaultMessage='regolamento Nexi' />,
  micropaymentsRegulationISP: <PortalMessage id='t.app.kitstart.main.micropayments.regulationISP' defaultMessage='regolamento Intesa Sanpaolo' />,
  micropaymentsRegulationMPS: <PortalMessage id='t.app.kitstart.main.micropayments.regulationMPS' defaultMessage='regolamento Monte dei Paschi' />,

  // Funzione dinamica per generare il testo completo dei regolamenti micropagamenti
  getMicropaymentsRegulationText: (additionalData) => {
    if (!additionalData) return null

    const links = []

    // Aggiungi il link Nexi se disponibile e non vuoto
    if (additionalData.regulationUrlNEXI && additionalData.regulationUrlNEXI.trim() !== '') {
      links.push({
        url: additionalData.regulationUrlNEXI,
        label: 'regolamento Nexi',
        id: 't.app.kitstart.main.micropayments.regulationNexi'
      })
    }

    // Aggiungi il link ISP se disponibile e non vuoto
    if (additionalData.regulationUrlISP && additionalData.regulationUrlISP.trim() !== '') {
      links.push({
        url: additionalData.regulationUrlISP,
        label: 'Intesa Sanpaolo',
        id: 't.app.kitstart.main.micropayments.regulationISP'
      })
    }

    // Aggiungi il link MPS se disponibile e non vuoto
    if (additionalData.regulationUrlMPS && additionalData.regulationUrlMPS.trim() !== '') {
      links.push({
        url: additionalData.regulationUrlMPS,
        label: 'Monte dei Paschi',
        id: 't.app.kitstart.main.micropayments.regulationMPS'
      })
    }

    if (links.length === 0) return null

    return {
      baseText: 'Messaggio pubblicitario con finalità promozionale. Per maggiori informazioni vai al',
      links,
      baseTextId: 't.app.kitstart.main.micropayments.text4'
    }
  },

  // Pay-by-Link service
  pblTitle: <PortalMessage id='t.app.kitstart.main.pbl.title' defaultMessage='Pay-by-Link' />,
  pblSubtitle: <PortalMessage id='t.app.kitstart.main.pbl.subtitle' defaultMessage='Inizia subito a farti pagare con un link.' />,
  pblDescription: <PortalMessage id='t.app.kitstart.main.pbl.description' defaultMessage={'Con Pay-by-Link accettare pagamenti è facile, sicuro e veloce. Grazie a questo servizio è possibile accettare pagamenti ovunque il cliente si trovi, tramite l\'invio di un semplice link. Inoltre, è possibile visualizzare tutti i link generati e lo stato dei pagamenti in tempo reale nella sezione Incassa.'} />,
  pblActivationCost: <PortalMessage id='t.app.kitstart.main.pbl.activationCost' defaultMessage='Costo di attivazione' />,
  pblMonthlyCost: <PortalMessage id='t.app.kitstart.main.pbl.monthlyCost' defaultMessage='Canone mensile' />,
  pblTransactionCost: <PortalMessage id='t.app.kitstart.main.pbl.transactionCost' defaultMessage='Costo a transazione' />,
  pblFooter: <PortalMessage id='t.app.kitstart.main.pbl.footer' defaultMessage='Le commissioni % per l’accettazione delle carte sono pari a quelle previste sul contratto di convenzionamento del tuo punto vendita fisico per le transazioni carta non presente.</br> Costi IVA esclusa.' />,
  pblMoreInfo: <PortalMessage id='t.app.kitstart.main.pbl.moreInfo' defaultMessage='Maggiori informazioni' />,

  // SoftPOS service
  getSoftposTitle: (serviceType) => {
    const isISP = serviceType === 'ISP_POS'
    return isISP
      ? <PortalMessage id='t.app.kitstart.main.softpos.title.isp' defaultMessage='SoftPOS aggiuntivo' />
      : <PortalMessage id='t.app.kitstart.main.softpos.title.nexi' defaultMessage='SoftPOS di supporto' />
  },
  // Retrocompatibilità - mantiene il vecchio nome per evitare breaking changes
  softposTitle: <PortalMessage id='t.app.kitstart.main.softpos.title' defaultMessage='SoftPOS aggiuntivo' />,
  getSoftposSubtitle: (service) => {
    const isISP = service.featureType === 'ISP_POS'
    const price = service.additionalData?.monthFee || (isISP ? '5' : '6')
    const date = service.additionalData?.softPosTryBuyPromoEndDate || '31/07/2026'
    const months = service.additionalData?.freeMonths || '6'
    return (
      <PortalMessage
        id={isISP ? 't.app.kitstart.main.softpos.subtitle.isp' : 't.app.kitstart.main.softpos.subtitle.nexi'}
        defaultMessage={`Richiedi Nexi SoftPOS entro il ${date} e ottieni ${months} mesi di canone gratis, poi continui a soli ${price}€ al mese.`}
      />
    )
  },
  // Retrocompatibilità - mantiene il vecchio nome per evitare breaking changes
  softposSubtitle: <PortalMessage id='t.app.kitstart.main.softpos.subtitle' defaultMessage='Richiedi Nexi SoftPOS entro il 31/07/2026 e ottieni 6 mesi di canone gratis, poi continui a soli 5€ al mese.' />,
  softposMonthlyCost: <PortalMessage id='t.app.kitstart.main.softpos.monthlyCost' defaultMessage='Canone mensile' />,
  softposTransactionCost: <PortalMessage id='t.app.kitstart.main.softpos.transactionCost' defaultMessage='Costo a transazione' />,
  softposPromoAmount: (months) => (
    <PortalMessage id='t.app.kitstart.main.softpos.promoAmount' defaultMessage='0€ per {months} mesi' values={{ months }} />
  ),
  getSoftposRegularAmount: (service) => {
    console.log('Generating SoftPOS regular amount for service type:', service) // Log per debugging
    const isISP = service.featureType === 'ISP_POS'
    const price = isISP ? '5€' : '6€'
    return (
      <PortalMessage
        id={isISP ? 't.app.kitstart.main.softpos.regularAmount.isp' : 't.app.kitstart.main.softpos.regularAmount.nexi'}
        defaultMessage={price}
      />
    )
  },
  // Retrocompatibilità - mantiene il vecchio nome per evitare breaking changes
  softposRegularAmount: <PortalMessage id='t.app.kitstart.main.softpos.regularAmount' defaultMessage='5€' />,
  softposTransactionAmount: <PortalMessage id='t.app.kitstart.main.softpos.transactionAmount' defaultMessage='0€' />,
  softposActivationCost: <PortalMessage id='t.app.kitstart.main.softpos.activationCost' defaultMessage='Costo di attivazione' />,
  softposActivationAmount: <PortalMessage id='t.app.kitstart.main.softpos.activationAmount' defaultMessage='0€' />,
  softposFooter: <PortalMessage id='t.app.kitstart.main.softpos.footer' defaultMessage='Costi IVA esclusa.' />,
  softposDescription: <PortalMessage id='t.app.kitstart.main.softpos.description' defaultMessage="Accetta pagamenti contactless semplicemente avvicinando la carta, il telefono o lo smartwatch del cliente al tuo telefono. Per incassare è necessario scaricare l'app <b>Nexi POS</b>." />,
  softposTerms: <PortalMessage id='t.app.kitstart.main.softpos.terms' defaultMessage="Per i pagamenti effettuati con Nexi SoftPOS verranno applicate le stesse condizioni commissiali del tuo POS principale. BANCOMAT® è abilitato solo su sistema operativo Android, i circuiti JCB, UPI e Discover al momento non sono disponibili. Al termine del periodo di prova, il servizio si rinnoverà automaticamente. Disattivalo in qualunque momento dalla sezione 'Dati Società' all'interno del tuo profilo." />,
  softposAndroidTitle: <PortalMessage id='t.app.kitstart.main.softpos.androidTitle' defaultMessage='Requisiti minimi del tuo dispositivo Android:' />,
  softposAndroidReqs: <PortalMessage id='t.app.kitstart.main.softpos.androidReqs' defaultMessage='sistema operativo Android con versione 8.1 o superiori e Antenna NFC.' />,
  softposIphoneTitle: <PortalMessage id='t.app.kitstart.main.softpos.iphoneTitle' defaultMessage='Requisiti minimi del tuo iPhone:' />,
  softposIphoneReqs: <PortalMessage id='t.app.kitstart.main.softpos.iphoneReqs' defaultMessage="iPhone XS e successivi e sistema operativo iOS aggiornato all'ultima versione (dalla 17 in poi). Non è compatibile con iPad." />,

  // Fallback for unsupported services
  unsupportedServiceTitle: <PortalMessage id='t.app.kitstart.main.unsupported.title' defaultMessage='Servizio non disponibile' />,

  // Services modal (KitStartRegistration) texts
  servicesPageTitle: <PortalMessage id='t.app.kitstart.services.pageTitle' defaultMessage='Prodotti e servizi' />,
  servicesMainTitle: <PortalMessage id='t.app.kitstart.services.mainTitle' defaultMessage='Attiva i servizi aggiuntivi Nexi' />,
  servicesMainSubtitle: <PortalMessage id='t.app.kitstart.services.mainSubtitle' defaultMessage='Per <b>semplificare la gestione della tua attività</b> e <b>accogliere ogni esigenza dei tuoi clienti</b>, Nexi ti mette a disposizione i seguenti servizi.' />,

  servicesMicropaymentsTitle: <PortalMessage id='t.app.kitstart.services.micropayments.title' defaultMessage='Micropagamenti' />,
  servicesMicropaymentsDescription: <PortalMessage id='t.app.kitstart.services.micropayments.description' defaultMessage='Attiva Micropagamenti e risparmia sulle commissioni.' />,

  servicesPblTitle: <PortalMessage id='t.app.kitstart.services.pbl.title' defaultMessage='Pay-By-Link' />,
  servicesPblDescription: <PortalMessage id='t.app.kitstart.services.pbl.description' defaultMessage='Incassa con Pay-By-Link: invia un link di pagamento al tuo cliente.' />,

  getServicesSoftposTitle: (serviceType) => {
    const isISP = serviceType === 'ISP_POS'
    return isISP
      ? <PortalMessage id='t.app.kitstart.services.softpos.title.isp' defaultMessage='SoftPOS aggiuntivo' />
      : <PortalMessage id='t.app.kitstart.services.softpos.title.nexi' defaultMessage='SoftPOS di supporto' />
  },
  // Retrocompatibilità - mantiene il vecchio nome per evitare breaking changes
  servicesSoftposTitle: <PortalMessage id='t.app.kitstart.services.softpos.title' defaultMessage='SoftPOS di supporto' />,
  servicesSoftposDescription: <PortalMessage id='t.app.kitstart.services.softpos.description' defaultMessage="Accetta pagamenti contactless direttamente dal tuo telefono con l'App Nexi POS. SoftPOS gratuito per i primi 6 mesi, poi a soli 6€ al mese." />,

  // Funzione per generare la descrizione dinamica del SoftPOS basata sui dati del servizio
  getServicesSoftposDescription: (freeMonths, monthFee) => {
    const months = freeMonths || '6'
    const fee = monthFee || '6'
    return (
      <PortalMessage
        id='t.app.kitstart.services.softpos.description.dynamic'
        defaultMessage={`Accetta pagamenti contactless direttamente dal tuo telefono con l'App Nexi POS. SoftPOS gratuito per i primi ${months} mesi, poi a soli ${fee}€ al mese.`}
        values={{ months, fee }}
      />
    )
  },

  servicesFreeLabel: <PortalMessage id='t.app.kitstart.services.badge.free' defaultMessage='Gratuito' />,
  servicesFreeTrialLabel: <PortalMessage id='t.app.kitstart.services.badge.freeTrial' defaultMessage='Gratis 6 mesi' />,

  // Funzione per generare il testo dinamico del badge basato sui freeMonths
  getFreeBadgeLabel: (freeMonths) => <PortalMessage id='t.app.kitstart.services.badge.freeMonths' defaultMessage={`Gratis ${freeMonths} mesi`} values={{ freeMonths }} />,

  servicesContinueLabel: <PortalMessage id='t.app.kitstart.services.continue' defaultMessage='CONTINUA' />,
  servicesCloseLabel: <PortalMessage id='t.app.kitstart.services.close' defaultMessage='chiudi' />
}

export default formattedMessage
